module.exports = __webpack_public_path__ + "img/MAC1132_1-1.828d2b44.jpg";